/*
 * サブシステム名：入金
 * 機能名：入金取込一覧
 */

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

const DdSearchList = () => import('@/components/DdSearchList')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'NyukinTorikomiList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdDateRangeBox,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      impStartYmdString: '',
      impEndYmdString: '',
      kinyuKikanCd: '',
      kinyuKikanShitenCd: ''
    },
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.impYmdDisp = filter.dateFormatter(elem.impYmd) + ' ' + elem.impHms.slice(0, 5)
        elem.nyukinGokeiKensuDisp = elem.nyukinGokeiKensu ? filter.numericFormatter(elem.nyukinGokeiKensu) : ''
        elem.miKakuteiGokeiKensuDisp = elem.miKakuteiGokeiKensu ? filter.numericFormatter(elem.miKakuteiGokeiKensu) : ''
        elem.kakuteiGokeiKensuDisp = elem.kakuteiGokeiKensu ? filter.numericFormatter(elem.kakuteiGokeiKensu) : ''
        elem.taishogaiGokeiKensuDisp = elem.taishogaiGokeiKensu ? filter.numericFormatter(elem.taishogaiGokeiKensu) : ''
        elem.nyukinGokeiKingakuDisp = elem.nyukinGokeiKingaku ? filter.numericFormatter(elem.nyukinGokeiKingaku) : ''
        elem.miKakuteiGokeiKingakuDisp = elem.miKakuteiGokeiKingaku ? filter.numericFormatter(elem.miKakuteiGokeiKingaku) : ''
        elem.kakuteiGokeiKingakuDisp = elem.kakuteiGokeiKingaku ? filter.numericFormatter(elem.kakuteiGokeiKingaku) : ''
        elem.taishogaiGokeiKingakuDisp = elem.taishogaiGokeiKingaku ? filter.numericFormatter(elem.taishogaiGokeiKingaku) : ''

        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
    })
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('NyukinTorikomiList.defineHeaderPromise')
            self.headers = [
              { text: '詳細', value: 'detailref', sortable: false, width: '20px' },
              { text: 'No', value: 'resultNo' },
              { text: '取込日時', value: 'impYmdDisp', align: 'center' },
              { text: '銀行コード', value: 'kinyuKikanCd' },
              { text: '支店コード', value: 'kinyuKikanShitenCd' },
              { text: '取込件数', value: 'nyukinGokeiKensuDisp', align: 'end' },
              { text: '未確定件数', value: 'miKakuteiGokeiKensuDisp', align: 'end' },
              { text: '確定件数', value: 'kakuteiGokeiKensuDisp', align: 'end' },
              { text: '対象外', value: 'taishogaiGokeiKensuDisp', align: 'end' },
              { text: '取込総額', value: 'nyukinGokeiKingakuDisp', align: 'end' },
              { text: '未確定金額', value: 'miKakuteiGokeiKingakuDisp', align: 'end' },
              { text: '確定済金額', value: 'kakuteiGokeiKingakuDisp', align: 'end' },
              { text: '対象外金額', value: 'taishogaiGokeiKingakuDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              impStartYmdString: filter.dateFormatter(new Date()),
              impEndYmdString: filter.dateFormatter(new Date()),
              kinyuKikanCd: '',
              kinyuKikanShitenCd: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('NyukinTorikomiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('NyukinTorikomiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('NyukinTorikomiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('NyukinTorikomiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('NyukinTorikomiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/TrNyukinTorikomiKihon/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },

    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              impStartYmdString: filter.dateFormatter(new Date()),
              impEndYmdString: filter.dateFormatter(new Date()),
              kinyuKikanCd: '',
              kinyuKikanShitenCd: ''
            }
            self.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowDetailButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    searchValidate: function () {
      var msg = validators.compareDate(this.conditions.impStartYmdString, this.conditions.impEndYmdString)
      if (msg !== undefined) {
        this.$refs.impStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.impEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      return true
    }
  }
}
